module.exports = __webpack_public_path__ + "img/dealer-icon-3.69b6b93b.png";